import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import Page from '../../common/Page/Page'
import PageCard from '../../common/PageCard'
import {
  SECRET_QUESTIONS,
  SECRET_QUESTIONS_AMOUNT,
  routes,
} from '../../../consts'
import MaterialSelectWithDropdown from '../../common/MaterialSelectWithDropdown'
import MaterialInput from '../../common/MaterialInput'
import Card from '../../common/Card'

import './SecretQuestions.css'

const SecretQuestions = () => {
  const dispatch = useDispatch()
  const [questions, setQuestions] = useState([])
  const [error, setError] = useState(null)
  const secretQuestionsError = useSelector(
    state => state.profile.secretQuestionsError
  )
  const isSecretQuestionUpdateLoading = useSelector(
    state => state.profile.isSecretQuestionUpdateLoading
  )
  const isSecretQuestions = useSelector(
    state => state.profile.userDetails?.isSecretQuestions
  )
  const secretQuestionsList = Object.values(SECRET_QUESTIONS).map(item => {
    return { label: $t(item.question), value: item.id }
  })
  const [selectedQuestionsKeys, setSelectedQuestionsKeys] = useState([])

  useEffect(() => {
    if (isSecretQuestions) {
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
    }
  }, [isSecretQuestions])

  const onChangeQuestion = (value, index) => {
    const newQuestions = [...questions]
    if (newQuestions[index]) {
      newQuestions[index].question_id = value
    } else {
      newQuestions[index] = { question_id: value }
    }
    const newSelectedQuestionsKeys = [...selectedQuestionsKeys]
    newSelectedQuestionsKeys[index] = value
    setSelectedQuestionsKeys(newSelectedQuestionsKeys)
    setQuestions(newQuestions)
  }

  const onChangeAnswer = (value, index) => {
    const newQuestions = [...questions]
    if (newQuestions[index]) {
      newQuestions[index].answer = value
    } else {
      newQuestions[index] = { answer: value }
    }
    setQuestions(newQuestions)
  }

  const isValidSecretQuestions = () => {
    return (
      questions.length === SECRET_QUESTIONS_AMOUNT &&
      questions.every(question => question?.question_id && question?.answer)
    )
  }

  const onSave = () => {
    if (isValidSecretQuestions()) {
      setError(null)
      dispatch(
        Actions.createAction(Actions.SECRET_QUESTION_UPDATE_REQUESTED, {
          questions,
        })
      )
    } else {
      setError($t('secretQuestions.error'))
    }
  }

  return (
    <PageCard className="login-page-card secret-questions-page-card">
      <Page
        hideAlertBanner
        loading={isSecretQuestionUpdateLoading}
        className="secret-questions-page"
        title={$t('secretQuestions.title')}
        subtitle={$t('secretQuestions.subtitle')}
      >
        <div className="questions-container">
          {[...Array(SECRET_QUESTIONS_AMOUNT)].map((_, i) => {
            return (
              <Card key={i} className="question-card">
                <h2 className="secret-question-header">
                  {$t('secretQuestions.secretQuestion', { number: i + 1 })}
                </h2>
                <MaterialSelectWithDropdown
                  popupClassName="secret-question-dropwon"
                  search={false}
                  data={secretQuestionsList.filter(
                    question =>
                      question?.value === questions[i]?.question_id ||
                      !selectedQuestionsKeys.includes(question?.value)
                  )}
                  value={
                    secretQuestionsList.find(
                      question => question?.value === questions[i]?.question_id
                    )?.label
                  }
                  label={$t('secretQuestions.select')}
                  onChange={value => onChangeQuestion(value, i)}
                />
                <MaterialInput
                  maxLength={50}
                  className="name-input"
                  value={questions[i]?.answer}
                  onChange={e => onChangeAnswer(e.target.value, i)}
                  label={$t('secretQuestions.yourAnswer')}
                />
              </Card>
            )
          })}
        </div>
        {error && <div className="error">{error}</div>}
        {secretQuestionsError && (
          <div className="error">{secretQuestionsError}</div>
        )}
        <Button
          key="1"
          className="save-secret-questions trackable"
          data-name="save-secret-questions"
          type="primary"
          onClick={onSave}
        >
          {$t('common.save')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default SecretQuestions
